<!-- 客户电话回访表单 -->
<template>
  <layui-collapse ref="collapse">
    <div class="layui-colla-item">
      <h2 class="layui-colla-title">客户回访信息</h2>
      <div class="layui-colla-content layui-show">
        <div class="layui-form-item-two">
          <div class="layui-form-item-left">
            <div class="layui-form-item">
              <label class="layui-form-label">服务态度：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.SERVE_STATE_DESC
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <layui-radio v-model="editRow.SERVE_STATE" name="SERVE_STATE">
                  <input type="radio" value="1" title="好" />
                  <input type="radio" value="2" title="一般" />
                  <input type="radio" value="3" title="差" />
                </layui-radio>
              </div>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">故障是否解决：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.FAULT_STATE_DESC
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <layui-radio v-model="editRow.FAULT_STATE" name="FAULT_STATE">
                  <input type="radio" value="1" title="是" />
                  <input type="radio" value="0" title="否" />
                </layui-radio>
              </div>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">工服情况：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.WORK_CLOTHES_STATE_DESC
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <layui-radio v-model="editRow.WORK_CLOTHES_STATE" name="WORK_CLOTHES_STATE">
                  <input type="radio" value="1" title="穿工服" />
                  <input type="radio" value="2" title="未穿工服" />
                </layui-radio>
              </div>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">工牌情况：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.BADGE_STATE_DESC
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <layui-radio v-model="editRow.BADGE_STATE" name="BADGE_STATE">
                  <input type="radio" value="1" title="戴工牌" />
                  <input type="radio" value="2" title="未戴工牌" />
                </layui-radio>
              </div>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">回访成功：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.RETURN_VISIT_SUCCESS_DESC
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <layui-radio v-model="editRow.RETURN_VISIT_SUCCESS" name="RETURN_VISIT">
                  <input type="radio" value="1" title="满意" />
                  <input type="radio" value="2" title="一般" />
                  <input type="radio" value="3" title="不满意" />
                </layui-radio>
              </div>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">回访失败：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.RETURN_VISIT_FAIL_DESC
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <layui-radio v-model="editRow.RETURN_VISIT_FAIL" name="RETURN_VISIT">
                  <input type="radio" value="1" title="未接听" />
                  <input type="radio" value="2" title="已接听" />
                  <input type="radio" value="3" title="未回应" />
                </layui-radio>
              </div>
            </div>
          </div>
          <div class="layui-form-item-right">
            <div class="layui-form-item">
              <label class="layui-form-label">被回访人姓名：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.BE_REVISITED_PERSON
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <input
                  type="text"
                  autocomplete="off"
                  class="layui-input"
                  name="BE_REVISITED_PERSON"
                  v-model="editRow.BE_REVISITED_PERSON"
                  placeholder="请输入被回访人姓名"
                />
              </div>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">被回访人电话：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.BE_REVISITED_PERSON_PHONE
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <input
                  type="text"
                  autocomplete="off"
                  class="layui-input"
                  name="BE_REVISITED_PERSON_PHONE"
                  v-model="editRow.BE_REVISITED_PERSON_PHONE"
                  placeholder="请输入被回访人电话"
                />
              </div>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">回访时间：</label>
              <label class="layui-form-label right" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.RETURN_VISIT_TIME
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <layui-datetime
                  name="RETURN_VISIT_TIME"
                  v-model="editRow.RETURN_VISIT_TIME"
                  placeholder="回访时间"
                ></layui-datetime>
              </div>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">备注：</label>
              <label class="layui-form-label right textarea" v-if="editRow.ORDER_STATE > '4' || !editable">{{
                editRow.RETURN_VISIT_BZ
              }}</label>
              <div class="layui-input-inline" style="width: 60%" v-if="editRow.ORDER_STATE == '4' && editable">
                <textarea
                  v-model="editRow.RETURN_VISIT_BZ"
                  placeholder="请输入备注"
                  name="RETURN_VISIT_BZ"
                  class="layui-textarea"
                >
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layui-collapse>
</template>
<script>
export default {
  props: {
    editRow: {
      default: () => ({}),
      type: Object,
    },
    enabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editable: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.editable = this.enabled
    })
  },

  // 将props中editRow的两个属性return出来
  computed: {
    RETURN_VISIT_SUCCESS: function () {
      return this.editRow.RETURN_VISIT_SUCCESS
    },
    RETURN_VISIT_FAIL: function () {
      return this.editRow.RETURN_VISIT_FAIL
    },
  },
  // 实现回访成功和回访失败的互斥访问
  watch: {
    RETURN_VISIT_SUCCESS: function (newVal, oldVal) {
      if (newVal !== '') {
        this.editRow.RETURN_VISIT_FAIL = ''
      }
    },
    RETURN_VISIT_FAIL: function (newVal, oldVal) {
      if (newVal !== '') {
        this.editRow.RETURN_VISIT_SUCCESS = ''
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/workOrder/detailForm/returnVisitForm.vue